export default "__VITE_ASSET__3b7bcad1__"